import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { BiggerPictureMessagesService } from '../services/bigger-picture-messages.service';

@Injectable({providedIn: 'root'})

export class BiggerPictureMessagesGuard implements CanActivate {
  constructor(private biggerPictureMessagesService: BiggerPictureMessagesService) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const moiArr: number[] = Array.isArray(route.data.moi) ? route.data.moi : [route.data.moi];
    const msgPromises: Promise<any>[] = [];
    for (const moi of moiArr) {
      msgPromises.push(await this.biggerPictureMessagesService.getMessages(moi));
    }
    await Promise.all(msgPromises);
    return true;
  }
}
